export enum AppPlans {
    Free = 'Free',
    Standard = 'Standard',
    Standard_Yearly = 'Standard Yearly',
    Team = 'Team',
}
